import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Talep } from '../model/talep';
import { Router } from '@angular/router';
import { Teklif } from '../model/teklif';
import { RestService } from 'src/providers/rest.service';
import { AuthService } from 'src/auth/auth.service';

@Component({
  selector: 'app-talep-liste',
  templateUrl: './talep-liste.component.html',
  styleUrls: ['./talep-liste.component.css']
})
export class TalepListeComponent implements OnInit {

  static _route:Router;
  talepler: Talep[] = null;
  pIsTalep: boolean = false;
  pIsFatura: boolean = false;
  pIsSiparis: boolean = false;
  pIsTeklif: boolean = false;
  pIsTeklifSiparis: boolean = false;
  pIsDeleteButtonShow:boolean = false;
  userGrupId: number;

  DURUM_ONAY_SURECI = Talep.DURUM_ONAY_SURECI;
  DURUM_TEKLIF_TOPLA = Talep.DURUM_TEKLIF_TOPLA;
  DURUM_SIPARIS_OLUSTURULDU = Talep.DURUM_SIPARIS_OLUSTURULDU;
  DURUM_CEVAPLANDI = Teklif.DURUM_CEVAPLANDI;
  DURUM_REVIZE_EDILDI = Teklif.DURUM_REVIZE_EDILDI;

  @Output() updateTalepler = new EventEmitter<boolean>();

  @Input()
  public set source(talepler: Talep[]) {
    if (talepler != null) {
      this.talepler = talepler;
    }
  }

  @Input()
  public set isTalep(pIsTalep: boolean) {
    this.pIsTalep = pIsTalep;
  }

  @Input()
  public set isFatura(pIsFatura: boolean) {
    this.pIsFatura = pIsFatura;
  }

  @Input()
  public set isSiparis(pIsSiparis: boolean) {
    this.pIsSiparis = pIsSiparis;
  }

  @Input()
  public set isDeleteButtonShow(pIsDeleteButtonShow:boolean){
    this.pIsDeleteButtonShow = pIsDeleteButtonShow
  }

  @Input()
  public set isTeklif(pIsTeklif: boolean) {
    this.pIsTeklif = pIsTeklif;
  }

  @Input()
  public set isTeklifSiparis(pIsTeklifSiparis: boolean) {
    this.pIsTeklifSiparis = pIsTeklifSiparis;
  }

  constructor(private router: Router,
    private restService: RestService,
    private authService: AuthService) {
      TalepListeComponent._route = router;
  }

  ngOnInit(): void {
    this.userGrupId = this.authService.getUser().kullaniciGrupId;
  }

  incele(t: Talep) {
    this.router.navigate(['talep'], { queryParams: { id: t.id, teklifler: this.pIsTeklif } });
  }

  teklifIste(t: Talep) {
    this.router.navigate(['talep'], { queryParams: { id: t.id, action: 'talep-iste' } });

  }

  siparisOlustur(t: Talep) {
    this.router.navigate(['siparis-olustur'], { queryParams: { id: t.id } });
  }

  talepSil(t:Talep){
    debugger;
    if(confirm("Talebi silmek istediğinizden emin misiniz?")){
      this.restService.talepSil(t.id).subscribe((res) => {
       debugger;
          window.location.reload();
       
      }); 
    }
  }

  isSiparisVerilebilir(t: Talep): boolean {
    return t.durum !== this.DURUM_ONAY_SURECI &&
      (
        (
          t.teklifler != null
          && this.isTeklifIstenebilir(t) && (t.teklifler.findIndex(x => x.durum === this.DURUM_CEVAPLANDI || x.durum === this.DURUM_REVIZE_EDILDI) !== -1)
        )
        || this.isTeklifIstenebilir(t)
      );

  }

  isTeklifIstenebilir(t: Talep): boolean {
    if (t.toplamSiparisEdilenMiktar !== null)
      return (t.toplamTalepEdilenMiktar - t.toplamSiparisEdilenMiktar > 0);

    return true;
  }

  iptalEt(id: number) {
    if (confirm("Silmek istediğinize emin misiniz?")) {
      this.restService.talepSil(id).subscribe(res => {
        if (res) {
          this.updateTalepler.emit(true);
        }
      });
    }
  }

  faturaOlustur(t: Talep) {
    this.router.navigate(['fatura'], { queryParams: { id: '0', talepId: t.id } });
  }
}
